/* eslint-disable react-hooks/rules-of-hooks */
/* eslint no-use-before-define: "error"*/
import {
    useState
} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import styles from './MLSpecialityListComponent.module.scss';
import metadata from './MLSpecialityListComponent.metadata.json5';
import MakeEditInput from './MakeEditInput.jsx';
import { IconButton } from '@jutro/components/internal.js';


const MLSpecialityListComponent = (props) => {
    const [specialityTableConfig, setSpecialityTableConfig] = useState({ editedRow: undefined })
    const {
        specialityVehicles,
        updateSubmissionVMOnBlur,
        selectedSpecialities, 
        rowEditableFor,
        onSpecialitySelectionChange,
        rowDisabled,
        onReadySpecialtyVehicleForEdit
    } = props;

    const renderMakeCell = (item) => {
        if (!item.make) return '-';
        return item.make;
    }

    const renderModelCell = (item) => {
        if (!item.model) return '-'
        return item.model;
    }

    const renderYearCell = (item) => {
        if (!item.year) return '-'
        return item.year;
    }

    const renderVehicleType = (item) => {
        const calculatedClassname = (rowDisabled?.includes(item.publicID)) ? 'row-disabled' : ''
        if (!item.productType) return <><span style={{width: '2px'}} className={calculatedClassname}></span>-</>
        return <><span style={{width: '2px'}} className={calculatedClassname}></span>{item.productType}</>;
    }

    const renderVehicleSubType = (item) => {
        if (!item.productSubType) return '-'
        return item.productSubType
    }

    const onSpecialityRowClick = (row) => {
        if(rowEditableFor.includes(row.productSubType)){
            setSpecialityTableConfig((prev) => ({
                ...prev,
                editedRow: row.publicID,
                focusTarget: { field: 'make' }
            }))
        }
    }

    const startEditOnRowClick = ({ row, index, onEditStart }) => {
        onEditStart(row, index);
    }

    const onSpecialityConfigChange = (nextConfig) => {
        setSpecialityTableConfig((prev) => ({
            ...prev,
            ...nextConfig,
            editedRow: nextConfig?.editedRow ?? prev?.editedRow,
            focusTarget: nextConfig?.focusTarget ?? prev?.focusTarget
        }))
    }

    const renderEditMakeCell = ({ editProps, editActions }) => {
        return <MakeEditInput
            row={editProps.row}
            rowId={editProps.rowId}
            editActions={editActions}
            specialityTableConfig={specialityTableConfig}
            updateSubmissionVMOnBlur={updateSubmissionVMOnBlur}
            setSpecialityTableConfig={setSpecialityTableConfig}
            modelKey='make'
        />
    }

    const renderEditModelCell = ({ editProps, editActions }) => {
        return <MakeEditInput
            row={editProps.row}
            rowId={editProps.rowId}
            editActions={editActions}
            specialityTableConfig={specialityTableConfig}
            updateSubmissionVMOnBlur={updateSubmissionVMOnBlur}
            setSpecialityTableConfig={setSpecialityTableConfig}
            modelKey='model'
        />
    }

    const renderEditIconCell = (item) => {
        const isEditableRow = rowEditableFor.includes(item.productSubType) || item.source === "Manual"
        if(!isEditableRow) return ''
        return <IconButton className="editIcon" icon="mi-edit" onClick={() => {
            if(item.source === "Manual"){
                onReadySpecialtyVehicleForEdit(item)
            }
        }} />
    }

    const overrideProps = {
        specialityListTable: {
            data: specialityVehicles ?? [],
            config: specialityTableConfig,
            onConfigChange: onSpecialityConfigChange,
            selectedRows: selectedSpecialities,
            onSelectionChange: onSpecialitySelectionChange,
            onRowClick: onSpecialityRowClick,
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            renderMakeCell,
            renderModelCell,
            renderYearCell,
            renderVehicleType,
            renderVehicleSubType,
            onSpecialityRowClick,
            onSpecialitySelectionChange,
            startEditOnRowClick,
            onSpecialityConfigChange,
            renderEditMakeCell,
            renderEditModelCell,
            renderEditIconCell
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLSpecialityListComponent.propTypes = {
    specialityVehicles: PropTypes.arrayOf(
        PropTypes.shape({})
    ).isRequired,
    accountNumber: PropTypes.string,
    policyNumber: PropTypes.string,
    onAddActivity: PropTypes.func.isRequired,
    history: PropTypes.shape({ push: PropTypes.func }).isRequired,
    isPcsIa: PropTypes.bool,
    onReadySpecialtyVehicleForEdit: PropTypes.func,

}

MLSpecialityListComponent.defaultProps = {
    isPcsIa: undefined
}

export default withRouter(withViewModelService(MLSpecialityListComponent));
